import React from 'react';
import{
    ActionButton,
    AddedText,
    ProductTemplateTitle,
    AddedCartButton,
    AddCartIcon, 
    TagContainer,
    ImageContainer,
    CounterDiv,
    Tissue,
    Status,
    StatusText,
    NonTissue,
    EAStatus,
    EAStatusText,
    SetCount,
    Type, 
    InputBox,
    CounterInput,
    SetName,
    Flex,
    FavoriteIconContainer,
    Icon,
}from '../SetsAndItems.styled';
import { useTranslation } from 'react-i18next';
import { CC_USER_ROLE, CSR_USER_ROLE, ITA_USER_ROLE, US_COUNTRY_CODE } from 'src/constants/appConstants';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import NonTissueIcon from 'src/assets/images/NonTissueItemIcon.svg';
import TissueItemIcon from 'src/assets/images/TissueItemIcon.svg';
import NonTissueItemIcon from 'src/assets/images/NonTissueItemIcon.svg'; 
import TissueIcon from 'src/assets/images/TissueIcon.svg';
import StepperAddBlue from 'src/assets/images/StepperAddBlue.svg';
import AlertCircleOutlinePink from 'src/assets/images/AlertCircleOutlinePink.svg';
import AddBlue from 'src/assets/images/AddBlue.svg';
import { logErrorToConsole } from 'src/utils/util';
import Loader from 'src/common/components/Loader.jsx';
import CheckMark from 'src/assets/images/CheckMark.svg';
import StepperRemoveBlue from 'src/assets/images/StepperRemoveBlue.svg';
import { BLACK_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';
import { useSelector } from 'react-redux';
import { getUser } from 'src/pages/equity/components/common/utils/eventHandlerUtil';
import { StyledTextDiv } from 'src/pages/equity/components/cart/priceOverride/utils/reportUsage.styled';
import { DARK_GRAY_FONT_COLOR, DARK_NAVY_FONT_COLOR,
    PINK_HIGHLIGHT_COLOR, SEMANTIC_TEXT_SMALL_PX } from '../../../../styles/fonts/MCFontConstants';
import { accountNumberZeroTrimmer } from 'src/utils/util';

const NameContainer = (props) => {
    const {
        isBundle = false,
        quickOrderFlag = false,
        setOrItemChildren,
        isOrderDetail = false,
        expandedCard,
        toggleCard = () => {},
        productCFN,
        productKey,
        cfn,
        bom,
        onSetItemClick = ()=>{},
        setOrItemDetails,
        setNameColor,
        clickable,
        isEquityOrder = false,
        isConsignmentAdd = false,
        setNameFontSizeDesktop,
        setNameFontSizeMobile,
        setNameLetterSpacing,
        enableTemplateCardSpecificStyling,
        setNameWidth,
        setNameTextOverflow,
        setNameOverflow,
        setNameStyle,
        priceOverridePage = false,
        reviewPage = false,
        salesOrg = '',
        uom,
        type,
        isBundleSubItem = false,
        isEquityProductGuide = false, 
        cartPage = false,
        isconsignmentAddOrder = false,
        isFromIndependentProductGuide = false,
        productTemplateHeader,
        isCounterButton = false,
        isOnlyPlusButton = false,
        isQuantity = false,
        quantity,
        marginRight = '',
        fontSize = '',
        bundleItems,
        bomdata,
        isFromCart = false,
        isTemplate = false,
        onBomClick = ()=>{},
        id = '',
        opentemplate,
        isEquity = false,
        countryISOCode,
        isEquityNT = false,
        isSet = false,
        typeFontSize,
        addCountTocard,
        loaderFlag = false,
        productAdded = false,
        isLanguageChanged = false,
        selectedSegment,
        productWithIsDeleteButtonPresent,
        productWithIsPlaceHolderSet,
        isPlaceHolder,
        isPlaceHolderAdded,
        isDeleteButtonPresent,
        removeCount = ()=>{},
        quantityValue,
        subitem = false,
        updateItemsCount,
        parentIndex,
        index,
        validateQuantity,
        setIsQuantityMoreThan50,
        isSurgery = false,
        setsQuantityCheck,
        addCount = ()=>{},
        isProductTemplate=false,
        isEquityTemplate=false,
        templateDetails=false,
        favoriteOrUnfavorite,
        isFavourite = false,
        FavoriteActive,
        FavoriteInactive,
        setFavoriteIconTop,
        createdBy
    }=props;
     
    const { isCondensedView } = useSelector((state) => ({ 
        isCondensedView: state.loginReducer.isCondensedView,
    }));

    const employeeRole = getUser();
    
    const specialCharactersRegex =
        /[ a-zA-Z`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

    const { t } = useTranslation(); 
    return (
        <>
            {(isBundle && setOrItemChildren && setOrItemChildren.length) ||
            (isBundle && isOrderDetail) ? (
                <ImageContainer
                    src={DownArrowFilter}
                    alt="down-arrow"
                    isExpanded={expandedCard.itemDetails}
                    onClick={() => {
                        try {
                            toggleCard(
                                'itemDetails',
                                !expandedCard.itemDetails
                            );
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    style={{
                        width: '11px',
                        height: '25px',
                        marginRight: (isOrderDetail && isBundle)? '10px' :''
                    }}
                />
            ) : null}
            <SetName
                id={`sets-items-set-name-${productKey || productCFN || cfn || bom || 'unknown'}`}                           
                onClick={() => {
                    try {
                        onSetItemClick(setOrItemDetails);
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
                color={isBundle ? DARK_NAVY_FONT_COLOR : setNameColor}
                clickable={isBundle ? false : clickable}
                fontSizeDesktop={setNameFontSizeDesktop}
                fontSizeMobile={setNameFontSizeMobile}
                setNameLetterSpacing={setNameLetterSpacing}
                enableTemplateCardSpecificStyling={
                    enableTemplateCardSpecificStyling
                }
                setNameWidth={setNameWidth}
                setNameTextOverflow={setNameTextOverflow}
                setNameOverflow={setNameOverflow}
                setNameStyle={setNameStyle}
                style={{
                    width:
                        (reviewPage || priceOverridePage) && isConsignmentAdd && '100%',
                    display:isConsignmentAdd && 'flex',
                }}
            >
                {(isOrderDetail && setOrItemDetails?.isOrderHistoryItem && setOrItemDetails?.productCFNBatch) || productCFN || cfn || bom}

                {/* Added for equity and con add*/}

                {
                    // ((isEquityOrder && !cartPage)
                    //     && !isEquityProductGuide && !bundleItems
                    //     && !isEquityProductSearch && !isOrderDetail)
                    //  ||
                isConsignmentAdd? (
                        salesOrg == 'S030' ? (
                        <Flex marginLeft= '100px' >
                            {isEquityOrder?
                                    <Tissue
                                        marginLeft={'0px'}
                                        style={{ marginTop: '5px' }}
                                    >
                                        <img
                                            src={TissueItemIcon}
                                            alt="T"
                                            style={{
                                                height: '18px',
                                                width: '24px',
                                                marginLeft: '-9px',
                                            }}
                                        />
                            </Tissue>:null}
                                <Status style={{ marginTop: '3px' }}>
                                <StatusText>
                                    {uom || type}
                                </StatusText>
                                </Status>
                            </Flex>
                    ) : (isEquityOrder && salesOrg == 'S002' && !isProductTemplate) || isConsignmentAdd 
                    || isBundleSubItem? (
                        <Flex marginLeft= '80px'>
                            {(isEquityOrder && !cartPage) && !isEquityProductGuide?
                                    <>
                                        <NonTissue
                                            marginLeft={'0px'}
                                            style={{ marginTop: '5px' }}
                                        >
                                            <img
                                                src={NonTissueItemIcon}
                                                alt="NT"
                                                style={{
                                                    height: '18px',
                                                    width: '24px',
                                                    marginLeft: '-9px',
                                                }}
                                            />
                                        </NonTissue>
                                        <Status style={{ marginTop: '3px' }}>
                                            <StatusText>
                                                {uom || type}
                                            </StatusText>
                                        </Status>
                                    </>
                                : null
                            }
                            
                            </Flex>
                        ) : null
                ) : null}

            </SetName>

            {createdBy &&
                employeeRole !== ITA_USER_ROLE &&
                employeeRole !== CC_USER_ROLE &&
                employeeRole !== CSR_USER_ROLE &&
                setFavoriteIconTop && (
                    <FavoriteIconContainer
                        id="favorite-icon-container"
                        onClick={favoriteOrUnfavorite}
                        enableTemplateCardSpecificStyling={
                            enableTemplateCardSpecificStyling
                        }
                        setFavoriteIconTop={setFavoriteIconTop}
                    >
                        <Icon
                            id="favorite-icon"
                            mobilePath={
                                isFavourite
                                    ? FavoriteActive
                                    : FavoriteInactive
                            }
                        />
                    </FavoriteIconContainer>
                )}

            {/* Added for consignment Order, test it for all flows */}
            {(reviewPage || priceOverridePage) &&
                !isconsignmentAddOrder ? (
                salesOrg == 'S030' ? (
                    <TagContainer
                        style={{
                            marginRight: priceOverridePage
                                ? '-112px'
                                : '-150px',
                        }}
                    >
                        <Status style={{ marginTop: '10px' }}>
                            <StatusText>{uom || type}</StatusText>
                        </Status>
                    </TagContainer>
                ) : (
                    <TagContainer
                        style={{
                            marginRight: priceOverridePage
                                ? '-112px'
                                : '-150px',
                        }}
                    >
                        <Status style={{ marginTop: '10px' }}>
                            <StatusText>{uom || type}</StatusText>
                        </Status>
                    </TagContainer>
                )
            ) : null}

            <Flex alignItems= 'center' >
                {bomdata?.some(
                    (item) =>
                        (item.prodcutCFN == productCFN ||
                            item.prodcutCFN == cfn) &&
                        item.billOfMaterialsHistory?.length > 0 &&
                        isFromCart
                ) && (
                    <Flex alignItems= 'center' >
                        <img
                            id={`bom-change-icon-${productCFN || cfn || bom || id}`}
                            src={AlertCircleOutlinePink}
                            height="24px"
                            width="24px"
                            style={{
                                cursor: 'pointer',
                                marginTop: '1.1px',
                            }}
                            onClick={() => {
                                try {
                                    onBomClick(setOrItemDetails);
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                        />
                        <span
                            id={`bom-change-text-${productCFN || cfn || bom || id}`}
                            style={{
                                color: PINK_HIGHLIGHT_COLOR,
                                cursor: 'pointer',
                                fontSize: SEMANTIC_TEXT_SMALL_PX,
                                fontWeight: '600',
                                marginLeft: '5px',
                                marginTop: '-1.3px',
                            }}
                            onClick={() => {
                                try {
                                    onBomClick(setOrItemDetails);
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                        >
                            {t('common.bomChange')}
                        </span>
                    </Flex>
                )}
            </Flex>

            <ProductTemplateTitle
                id={`product-template-title-${productCFN || cfn || bom || id}`}
                onClick={() => {
                    {
                        opentemplate();
                    }
                }}
            >
                {productTemplateHeader}
            </ProductTemplateTitle>

            {  (isBundleSubItem && !cartPage)?
                salesOrg == 'S030' ? 
                    <Flex marginLeft= '100px'> 
                        <Tissue
                            marginLeft={'0px'}
                            style={{ marginTop: '5px', marginRight: '10px'}}
                        >
                            <img
                                src={TissueItemIcon}
                                alt="T"
                                style={{
                                    height: '18px',
                                    width: '24px',
                                    marginLeft: '-9px',
                                }}
                            />
                        </Tissue>
                        <EAStatus style={{ marginTop: '3px' }}>
                            <EAStatusText>
                                {uom || type}
                            </EAStatusText>
                        </EAStatus>
                    </Flex>
                : salesOrg == 'S002' ? 
                    <Flex marginLeft= '80px' >
                        <NonTissue
                            marginLeft={'0px'}
                            style={{ marginTop: '5px',marginRight: '10px' }}
                        >
                            <img
                                src={NonTissueItemIcon}
                                alt="NT"
                                style={{
                                    height: '18px',
                                    width: '24px',
                                    marginLeft: '-9px',
                                }}
                            />
                        </NonTissue>
                        <EAStatus style={{ marginTop: '3px' }}>
                            <EAStatusText>
                                {uom || type}
                            </EAStatusText>
                        </EAStatus>
                    </Flex> : null : null
                    }

            {(bundleItems?.length > 0  && !isEquityTemplate && !templateDetails && !isTemplate) && (
                    <Status marginTop={'3px'}>
                        <StatusText>
                        {isEquity || isEquityOrder ? t('equity.common.bundleItems.bundle') : 
                        isConsignmentAdd ? t('ConsignmentAdd.common.setsAndItems.bundle') : null}
                        </StatusText>
                    </Status>
                )}

            {(isQuantity && quantity ) && (
                <Flex display= 'inline-flex'>
                    {countryISOCode === US_COUNTRY_CODE &&
                        (isEquityOrder && !bundleItems && !isOrderDetail && !isProductTemplate) && (
                            <div style={{ marginRight: '10px' }}>
                                {isEquityNT ? (
                                    <img
                                        style={{ marginTop: '3px' }}
                                        src={NonTissueIcon}
                                        alt="NT"
                                    />
                                ) : (
                                    <img
                                        style={{ marginTop: '3px' }}
                                        src={TissueIcon}
                                        alt="T"
                                    />
                                )}
                            </div>
                        )}
                    <SetCount
                        marginRight={marginRight}
                        fontSize={fontSize}
                        mobileMarginRight={bundleItems ? '25px' : marginRight}
                    >
                        {(isEquityOrder && !bundleItems && !isProductTemplate) && (
                                <span style={{ marginRight: '10px' }}>
                                    {isEquityNT ? (
                                    <img style={{ marginTop: '3px', marginBottom: isOrderDetail ? '-5px' : '0' }} src={NonTissueIcon} alt="NT" />
                                    ) : (
                                    <img style={{ marginTop: '3px', marginBottom: isOrderDetail ? '-5px' : '0'  }} src={TissueIcon} alt="T" />
                                    )}
                                </span>
                            )}
                        {quantity} x
                        <Type typeFontSize={typeFontSize}>
                            {isSet
                                ? t(
                                        'orders.shipTrackLabels.setLabel'
                                    )
                                : uom || type}
                        </Type>
                    </SetCount>
                </Flex>
                
            )}

            {priceOverridePage && (
                <StyledTextDiv
                    color={DARK_GRAY_FONT_COLOR}
                    fontSize={SEMANTIC_TEXT_SMALL_PX}
                    textAlign={'center'}
                    style={{ marginRight: '12px' }}
                >
                    {t('equity.common.feesAndItems.qty')}
                </StyledTextDiv>
            )}

            {isCounterButton && (
                <ActionButton>
                    {!quickOrderFlag && ( //added flag for equity
                        <>
                            <AddedCartButton
                                id={`remove-cart-btn-${
                                    cfn || bom || productCFN
                                }`}
                                className={
                                    quantity <= 0 ||
                                    isPlaceHolderAdded ||
                                    isDeleteButtonPresent === false
                                        ? 'disabled'
                                        : ''
                                }
                                width={'29px'}
                                height={'29px'}
                                border={'unset'}
                                visibility={
                                    isDeleteButtonPresent === false
                                        ? 'hidden'
                                        : ''
                                }
                                onClick={() => {
                                    try {
                                        isEquityOrder || isConsignmentAdd
                                            ? removeCount(quantityValue)
                                            : removeCount();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                boxShadow={
                                    subitem
                                        ? '0px 0px 1px #00000029'
                                        : '0px 0px 2px #00000029'
                                }
                            >
                                {/* {loaderFlag ?
                                <Loader/> : */}
                                <AddCartIcon
                                    mobilePath={StepperRemoveBlue}
                                    width={'19px'}
                                    height={'19px'}
                                onClick={()=>{
                                    try {
                                        addCountTocard();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                />
                                {/* } */}
                            </AddedCartButton>
                    </>)}

                    {quickOrderFlag ? (
                        <InputBox
                            type="text"
                            maxLength="3"
                            value={setOrItemDetails.quantity}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (
                                    !specialCharactersRegex.test(
                                        value
                                    )
                                ) {
                                    updateItemsCount(
                                        parentIndex,
                                        value,
                                        productKey,
                                        index
                                    );
                                }
                            }}
                            disabled={
                                setOrItemDetails.quantity === 0
                            }
                        />
                    ) : (
                        // Counter for COnsignmentAdd, Equity Order and template
                        isConsignmentAdd || isEquityOrder?
                        <CounterInput color={BLACK_FONT_COLOR} 
                            type="text"
                            value={quantityValue}
                            onChange={(e) => {
                                validateQuantity(accountNumberZeroTrimmer(e.target.value));
                            }}
                            onBlur={() =>
                                isConsignmentAdd && setIsQuantityMoreThan50(false)
                            }
                    >  
                        </CounterInput>
                        :
                        //Counter for ScheduleSurgery
                        <CounterDiv style={{color: BLACK_FONT_COLOR, margin:'auto 0px', padding:'0 10px'}}>{quantity}</CounterDiv>
                    )}
                    {!quickOrderFlag && (
                        <>
                            <AddedCartButton
                            id={`add-cart-btn-${
                                cfn || bom || productCFN
                            }`}
                                className={
                                    quantity >= 50 ||
                                    (isSurgery &&
                                    !setsQuantityCheck(
                                        setOrItemDetails
                                    )) ||
                                    isPlaceHolderAdded ||
                                (!isSet &&
                                    isDeleteButtonPresent === false)
                                        ? 'disabled'
                                        : ''
                                }
                                visibility={
                                !isSet &&
                                isDeleteButtonPresent === false
                                        ? 'hidden'
                                        : ''
                                }
                                width={'29px'}
                                height={'29px'}
                                border={'unset'}
                                onClick={() => {
                                    try {
                                        isEquityOrder || isConsignmentAdd
                                            ? addCount(quantityValue)
                                            : addCount();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                boxShadow={
                                    subitem
                                        ? '0px 0px 1px #00000029'
                                        : '0px 0px 2px #00000029'
                                }
                            >
                            {!isCounterButton && loaderFlag ?
                                <Loader/> :
                                    <AddCartIcon
                                        mobilePath={StepperAddBlue}
                                        width={'19px'}
                                        height={'19px'}
                                onClick={()=>{
                                    try {
                                        addCountTocard();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                    />
                                }
                            </AddedCartButton>
                    </>)}
                </ActionButton>
            )}
            {isOnlyPlusButton && !isFromIndependentProductGuide && ( //This is for Header plus
                    <ActionButton
                        enableTemplateCardSpecificStyling={
                            enableTemplateCardSpecificStyling
                        }
                        center={enableTemplateCardSpecificStyling}
                        //onClick={() => addCard()}
                    >
                        {productAdded ? (
                            <>
                            <AddedText isLanguageChanged={isLanguageChanged}>
                                {isEquity ? t('equity.common.bundleItems.added') : 
                                isConsignmentAdd ? t('ConsignmentAdd.common.setsAndItems.added') : 
                                t('templates.common.addItemBundlePop.setsAndItems.added')}
                                </AddedText>
                                {/* Remove added */}
                                <img
                                    src={CheckMark}
                                    width={'30px'}
                                    height={'30px'}
                                    //onClick={() => addCard()}
                                />
                            </>
                        ) : null}
                    {!productAdded  && (
                            <>
                                <AddedCartButton
                                id={`add-cart-btn-noncondensed-${cfn || bom || productCFN}`}
                                    width={isCondensedView && '29px'}
                                    height={isCondensedView && '29px'}
                                    // shadow={
                                    //     isCondensedView && 'none'
                                    // }
                                    className={
                                        isPlaceHolder ||
                                        productWithIsPlaceHolderSet?.some(
                                            (data) => data.cfn === cfn
                                        ) ||
                                        (!isSet &&
                                            productWithIsDeleteButtonPresent?.some(
                                            (data) =>
                                                data.cfn === cfn
                                            ))
                                            ? 'disabled'
                                            : ''
                                    }
                                    visibility={
                                        (selectedSegment == 1 &&
                                            isSet &&
                                            isEquity) ||
                                        (!isSet &&
                                            productWithIsDeleteButtonPresent?.some(
                                            (data) =>
                                                data.cfn === cfn
                                            ))
                                            ? 'hidden'
                                            : ''
                                    }
                                >
                                {loaderFlag ?
                                <Loader/> :
                                        <AddCartIcon
                                            width={'19px'}
                                            height={'19px'}
                                    mbHeight={
                                        isCondensedView && '29px'
                                    }
                                    mbWidth={
                                        isCondensedView && '29px'
                                    }
                                    mobilePath = {StepperAddBlue}
      
                                    onClick={()=>{
                                        try {
                                            addCountTocard();
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                />}
                                </AddedCartButton>
                            </>
                        )}
                    </ActionButton>
                )}
        </>
    );
};

export default NameContainer;